import { render, staticRenderFns } from "./crudPaymentConfig.vue?vue&type=template&id=1b958ddc&scoped=true"
import script from "./crudPaymentConfig.vue?vue&type=script&lang=js"
export * from "./crudPaymentConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b958ddc",
  null
  
)

export default component.exports